
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert } from "@mui/material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import DriverShipmentDestinationLoadingForm from "./ShipmentLoadingComponents/DriverShipmentRegularLoadingForm";
import { useAddFreeloadingForDriversMutation } from "store/services/freeloadingApi";



const DriverShipmentFreeLoadingRegularCreateScreen = () => {

    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Shipment Loading", path: "/app/driver/loading" },
        { title: "New Free Loading For Driver" },
    ];

    // RTK query hook for adding freeloading
    const [addFreeloading, { isLoading }] = useAddFreeloadingForDriversMutation();

    const handleCreateFreeloading = async (data) => {
        try {
            const response = await addFreeloading(data).unwrap();
            const freeloadingId = response?.loading?._id;
            if (!freeloadingId) {
                throw new Error("Freeloading ID not found in response");
            }
            toast.success("Freeloading successfully created!");
            navigate(`/app/driver/loading/${freeloadingId}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't create freeloading!"
            );
        }
    };


    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
            <BreadcrumbLayout.Paper>

                <Alert severity="info" sx={{ mb: 2 }}>
                    To collect shipments, you must add a price with <strong>Charge</strong> type first.
                </Alert>

                <DriverShipmentDestinationLoadingForm
                    isBusy={isLoading}
                    onSubmit={handleCreateFreeloading}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default DriverShipmentFreeLoadingRegularCreateScreen;




